/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServiceTypeEnum } from './serviceTypeEnum';
import { VcdsServiceTypeEnum } from './vcdsServiceTypeEnum';


export interface AgentOAuthAppSpec { 
    /**
     * Time limit for access token in seconds.
     */
    access_token_ttl?: number;
    /**
     * Agent ID
     */
    agent_id: string;
    /**
     * Choice of client id to be used while creating crdentials. <br> Typical format [service type]-[org id]-[vcds service type]-[resource id]-[AGENT]-[agent id]-[SERVER].
     */
    client_id?: string;
    org_id: string;
    /**
     * A resource identifier that, in the scope of service_type and vcds_service_type uniquely identifies the specific context that the agent will handle. For example for unmanaged (i.e. on-prem) DPX deployment (service_type=\'VCDR\', vcds_service_type=\'SRM\'), resource_id will be the vCenter UUID; for VSR - SDDC ID.
     */
    resource_id: string;
    service_type: ServiceTypeEnum;
    vcds_service_type: VcdsServiceTypeEnum;
}
export namespace AgentOAuthAppSpec {
}


